import { Actor, HttpAgent } from '@dfinity/agent';
import { AuthClient } from "@dfinity/auth-client";
import { sha224 } from '@dfinity/principal/lib/esm/utils/sha224';
import { getCrc32 } from '@dfinity/principal/lib/esm/utils/getCrc';
import { Principal } from "@dfinity/principal"; 
import { StoicIdentity } from "./stoicIdentity";

import { idlFactory as icp_bunny_idl, canisterId as icp_bunny_id } from 'dfx-generated/prod_icpbunny';
import { ConstructType } from '@dfinity/agent/lib/cjs/idl';

/*
1. Add the parameters to the canisters
2. Pull the redeemed Bunnies from the canisters
3. Verify UI to disable the redeemed bunny  devburgerFinanceCanisterID
*/

const bunnyCanisterId = 'xkbqi-2qaaa-aaaah-qbpqq-cai';
const burgerFinanceCanisterID = '4pdwa-uaaaa-aaaah-qc6ha-cai';
const devburgerFinanceCanisterID = '6s6yi-hiaaa-aaaah-qc6iq-cai';
const carrotCanisterId = "2qrsq-uiaaa-aaaai-aa3zq-cai";
const LEDGER_CANISTER_ID = "ryjl3-tyaaa-aaaaa-aaaba-cai";

const g_carrot_principal_ID = "axw33-yxlyu-npjjf-4b3k3-h5p3h-ikzeh-4dkff-wn7cv-52f72-ah2kc-tae";
const nCarrots = 999 * 100000000;
const payCarrots = 999;

let g_principalID = null;
let bunnyActor = null;
let carrotActor = null;
let burgerShop = null;

let isWalletConnected = false;
let ledgerActor = null;
let decimals = 100000000;

let isPlugWallet = false;


const storage = [];
storage[0] = "efqhu-yqaaa-aaaaf-qaeda-cai";
storage[1] = "ecrba-viaaa-aaaaf-qaedq-cai";
storage[2] = "fp7fo-2aaaa-aaaaf-qaeea-cai";
storage[3] = "fi6d2-xyaaa-aaaaf-qaeeq-cai";
storage[4] = "fb5ig-bqaaa-aaaaf-qaefa-cai";

storage[5] = "fg4os-miaaa-aaaaf-qaefq-cai";
storage[6] = "ft377-naaaa-aaaaf-qaega-cai";
storage[7] = "fu2zl-ayaaa-aaaaf-qaegq-cai";
storage[8] = "f5zsx-wqaaa-aaaaf-qaeha-cai";
storage[9] = "f2yud-3iaaa-aaaaf-qaehq-cai";

var privateKey = [1957,309,103,57,19,3];
var RSAKey     = [3,19,57,103,309,1957];

let myTokens = [];

var hashBackground = 0;
var hashSauce = 0;
var hashMeat = 0;
var hashCheese = 0;
var hashToppings = 0;
var hashBun = 0;
var selectedBunny = 0;
var isShopClosed = true;
var burgerAvailable = 0;
var isPayICP = false;
var isDemoMode = false;
var bunnyLoaded = false;
var isPaid = false;

var isPrincipalClaimed  = false;
const whitelist = [LEDGER_CANISTER_ID,carrotCanisterId,bunnyCanisterId,burgerFinanceCanisterID,storage[0],storage[1],storage[2],storage[3],storage[4],storage[5],storage[6],storage[7],storage[8],storage[9],];


const burgerFactory = ({ IDL }) => {
  const Property = IDL.Record({ 'value' : IDL.Text, 'name' : IDL.Text });
  const BurgerRequest = IDL.Record({
    'icp' : IDL.Nat,
    'owner' : IDL.Principal,
    'desc' : IDL.Text,
    'name' : IDL.Text,
    'properties' : IDL.Vec(Property),
    'blockheight' : IDL.Nat,
    'bunny_id' : IDL.Nat,
    'carrot' : IDL.Nat,
    'amount' : IDL.Nat,
  });
  const Time = IDL.Int;
  const BurgerDesc = IDL.Record({
    'id' : IDL.Nat,
    'url' : IDL.Text,
    'owner' : IDL.Principal,
    'date_of_order' : Time,
    'desc' : IDL.Text,
    'name' : IDL.Text,
    'properties' : IDL.Vec(Property),
    'bunny_id' : IDL.Nat,
  });

  return IDL.Service({
    'assembleBurger' : IDL.Func([BurgerRequest, IDL.Nat], [BurgerDesc], []),
    'burgerAvailable' : IDL.Func([], [IDL.Nat], ['query']),
    'burgerSold' : IDL.Func([], [IDL.Nat], ['query']),
    'isBunnyClaimed' : IDL.Func([IDL.Nat], [IDL.Bool], ['query']),
    'isShopClosed' : IDL.Func([], [IDL.Bool], ['query']),
  });
};

const carrotFactory = ({ IDL }) => {
  const TokenIdentifier = IDL.Text;
  const AccountIdentifier_2 = IDL.Text;
  const AccountIdentifier = AccountIdentifier_2;
  const User = IDL.Variant({
    principal: IDL.Principal,
    address: AccountIdentifier,
  });
  const BalanceRequest_2 = IDL.Record({
    token: TokenIdentifier,
    user: User,
  });
  const BalanceRequest = BalanceRequest_2;
  const Balance = IDL.Nat;
  const CommonError_2 = IDL.Variant({
    InvalidToken: TokenIdentifier,
    Other: IDL.Text,
  });
  const Result_4 = IDL.Variant({ ok: Balance, err: CommonError_2 });
  const BalanceResponse_2 = Result_4;
  const BalanceResponse = BalanceResponse_2;
  const Memo = IDL.Vec(IDL.Nat8);
  const SubAccount_2 = IDL.Vec(IDL.Nat8);
  const SubAccount = SubAccount_2;
  const TransferRequest_2 = IDL.Record({
    to: User,
    token: TokenIdentifier,
    notify: IDL.Bool,
    from: User,
    memo: Memo,
    subaccount: IDL.Opt(SubAccount),
    amount: Balance,
  });
  const TransferRequest = TransferRequest_2;
  const Result = IDL.Variant({
    ok: Balance,
    err: IDL.Variant({
      CannotNotify: AccountIdentifier,
      InsufficientBalance: IDL.Null,
      InvalidToken: TokenIdentifier,
      Rejected: IDL.Null,
      Unauthorized: AccountIdentifier,
      Other: IDL.Text,
    }),
  });
  const TransferResponse_2 = Result;
  const TransferResponse = TransferResponse_2;
  const Extension_2 = IDL.Text;
  const Extension = Extension_2;
  const AccountIdentifier_3 = AccountIdentifier;
  const Balance_2 = Balance;
  const TokenIdentifier_2 = TokenIdentifier;
  const Metadata_2 = IDL.Variant({
    fungible: IDL.Record({
      decimals: IDL.Nat8,
      metadata: IDL.Opt(IDL.Vec(IDL.Nat8)),
      name: IDL.Text,
      symbol: IDL.Text,
    }),
    nonfungible: IDL.Record({ metadata: IDL.Opt(IDL.Vec(IDL.Nat8)) }),
  });
  const Metadata = Metadata_2;
  const CommonError = CommonError_2;
  const Result_3 = IDL.Variant({ ok: Metadata, err: CommonError });
  const Result_2 = IDL.Variant({ ok: Balance_2, err: CommonError });
  return IDL.Service({
    acceptCycles: IDL.Func([], [], []),
    availableCycles: IDL.Func([], [IDL.Nat], ["query"]),
    balance: IDL.Func([BalanceRequest], [BalanceResponse], ["query"]),
    balance_of: IDL.Func([IDL.Principal], [IDL.Nat], ["query"]),
    totalsupply: IDL.Func([], [IDL.Nat], ["query"]),
    holders: IDL.Func([], [IDL.Nat], ["query"]),
    carrotTransfer: IDL.Func([TransferRequest], [TransferResponse], []),
    claimCarrots: IDL.Func([], [IDL.Nat], []),
    claimTokenCarrots: IDL.Func([IDL.Nat], [IDL.Text], []),
    extensions: IDL.Func([], [IDL.Vec(Extension)], ["query"]),
    getDebug: IDL.Func([], [IDL.Text], ["query"]),
    getOwner: IDL.Func([], [IDL.Principal], ["query"]),
    getOwners: IDL.Func(
      [],
      [IDL.Vec(IDL.Tuple(AccountIdentifier_3, Balance_2))],
      []
    ),
    metadata: IDL.Func([TokenIdentifier_2], [Result_3], ["query"]),
    registry: IDL.Func(
      [],
      [IDL.Vec(IDL.Tuple(AccountIdentifier_3, Balance_2))],
      ["query"]
    ),
    supply: IDL.Func([TokenIdentifier_2], [Result_2], ["query"]),
    testTransfer: IDL.Func([IDL.Text, IDL.Text], [IDL.Text], []),
    transfer: IDL.Func([TransferRequest], [TransferResponse], []),
    walletTransfer : IDL.Func([IDL.Nat, IDL.Text], [IDL.Text], []),
    wallet_receive: IDL.Func([], [IDL.Record({ accepted: IDL.Nat64 })], []),
  });
};

const ledgerFactory = ({ IDL }) => {
  const AccountIdentifier = IDL.Text;
  const Duration = IDL.Record({ 'secs' : IDL.Nat64, 'nanos' : IDL.Nat32 });
  const ArchiveOptions = IDL.Record({
    'max_message_size_bytes' : IDL.Opt(IDL.Nat32),
    'node_max_memory_size_bytes' : IDL.Opt(IDL.Nat32),
    'controller_id' : IDL.Principal,
  });
  const ICPTs = IDL.Record({ 'e8s' : IDL.Nat64 });
  const LedgerCanisterInitPayload = IDL.Record({
    'send_whitelist' : IDL.Vec(IDL.Tuple(IDL.Principal)),
    'minting_account' : AccountIdentifier,
    'transaction_window' : IDL.Opt(Duration),
    'max_message_size_bytes' : IDL.Opt(IDL.Nat32),
    'archive_options' : IDL.Opt(ArchiveOptions),
    'initial_values' : IDL.Vec(IDL.Tuple(AccountIdentifier, ICPTs)),
  });
  const AccountBalanceArgs = IDL.Record({ 'account' : AccountIdentifier });
  const CanisterId = IDL.Principal;
  const HeaderField = IDL.Tuple(IDL.Text, IDL.Text);
  const HttpRequest = IDL.Record({
    'url' : IDL.Text,
    'method' : IDL.Text,
    'body' : IDL.Vec(IDL.Nat8),
    'headers' : IDL.Vec(HeaderField),
  });
  const HttpResponse = IDL.Record({
    'body' : IDL.Vec(IDL.Nat8),
    'headers' : IDL.Vec(HeaderField),
    'status_code' : IDL.Nat16,
  });
  const SubAccount = IDL.Vec(IDL.Nat8);
  const BlockHeight = IDL.Nat64;
  const NotifyCanisterArgs = IDL.Record({
    'to_subaccount' : IDL.Opt(SubAccount),
    'from_subaccount' : IDL.Opt(SubAccount),
    'to_canister' : IDL.Principal,
    'max_fee' : ICPTs,
    'block_height' : BlockHeight,
  });
  const Memo = IDL.Nat64;
  const TimeStamp = IDL.Record({ 'timestamp_nanos' : IDL.Nat64 });
  const SendArgs = IDL.Record({
    'to' : AccountIdentifier,
    'fee' : ICPTs,
    'memo' : Memo,
    'from_subaccount' : IDL.Opt(SubAccount),
    'created_at_time' : IDL.Opt(TimeStamp),
    'amount' : ICPTs,
  });
  return IDL.Service({
    'account_balance_dfx' : IDL.Func([AccountBalanceArgs], [ICPTs], ['query']),
    'get_nodes' : IDL.Func([], [IDL.Vec(CanisterId)], ['query']),
    'http_request' : IDL.Func([HttpRequest], [HttpResponse], ['query']),
    'notify_dfx' : IDL.Func([NotifyCanisterArgs], [], []),
    'send_dfx' : IDL.Func([SendArgs], [BlockHeight], []),
  });
};

const bunnyFactory = ({ IDL }) => {
        const Property = IDL.Record({ 'value' : IDL.Text, 'name' : IDL.Text });
        const MintRequest_2 = IDL.Record({
          'url' : IDL.Text,
          'dataurl' : IDL.Text,
          'accountid' : IDL.Text,
          'contentType' : IDL.Text,
          'data' : IDL.Vec(IDL.Nat8),
          'desc' : IDL.Text,
          'name' : IDL.Text,
          'properties' : IDL.Vec(Property),
        });
        const MintRequest = MintRequest_2;
        const Time = IDL.Int;
        const TokenDesc_2 = IDL.Record({
          'id' : IDL.Nat,
          'url' : IDL.Text,
          'owner' : IDL.Principal,
          'desc' : IDL.Text,
          'name' : IDL.Text,
          'properties' : IDL.Vec(Property),
          'date_of_birth' : Time,
          'storage_canister' : IDL.Text,
        });
        const RarirtyRequest_2 = IDL.Record({
          'desc' : IDL.Text,
          'name' : IDL.Text,
          'properties' : IDL.Vec(Property),
        });
        const RarirtyRequest = RarirtyRequest_2;     
        const TokenDesc = TokenDesc_2;
    return IDL.Service({
        'getPrice' : IDL.Func([], [IDL.Nat64], []),
        'getCurrentToken' : IDL.Func([], [IDL.Nat], ['query']),
        'nextAccount' : IDL.Func([], [], []),
        'claim' : IDL.Func([], [IDL.Nat], []),
        'mint' : IDL.Func([MintRequest], [IDL.Nat], []),
        'setRarity' : IDL.Func([IDL.Nat, RarirtyRequest, IDL.Nat], [TokenDesc], []),
        'my_tokens' : IDL.Func([], [IDL.Vec(IDL.Nat)], []),
        'transfer_to' : IDL.Func([IDL.Principal, IDL.Nat], [IDL.Bool], []),
        'user_tokens' : IDL.Func([IDL.Principal], [IDL.Vec(IDL.Nat)], ['query']),
    });
};



const initPlugWallet = async () => {
    // Canister Ids
    const bunnyCanisterId = "xkbqi-2qaaa-aaaah-qbpqq-cai";
    const carrotCanisterId = "2qrsq-uiaaa-aaaai-aa3zq-cai";

    // Whitelist
    const whitelist = [LEDGER_CANISTER_ID,carrotCanisterId,bunnyCanisterId,burgerFinanceCanisterID,storage[0],storage[1],storage[2],storage[3],storage[4],storage[5],storage[6],storage[7],storage[8],storage[9]];

    // Host
    const host = "https://mainnet.dfinity.network";
  
    if (window.ic === undefined) {
       alert("Please install the Plug Extension to continue.");
      return 0;
    }
  
    let result = "";
    let connectionState = "";
  
    try {
      result = await window.ic.plug.requestConnect({
        whitelist,
        host,
      });
  
      connectionState = result ? "allowed" : "denied";
      console.log(`The Connection was ${connectionState}!`);

      if(connectionState === "allowed")
      {
        document.getElementById("Check-Claim").style.display = "flex";
      }
    } catch (e) {
      connectionState = result ? "allowed" : "denied";
      console.log("Exception " + e + " in window.ic.plug.requestConnect " + e.message);
      console.log(`The Connection was ${connectionState}!`);
      return -1;
    }
    
    // Plug-wallet
    bunnyActor = await window.ic.plug.createActor({
      canisterId: bunnyCanisterId,
      interfaceFactory: bunnyFactory,
    });

    carrotActor = await window.ic.plug.createActor({
      canisterId: carrotCanisterId,
      interfaceFactory: carrotFactory,
    });

    burgerShop = await window.ic.plug.createActor({
      canisterId: burgerFinanceCanisterID,
      interfaceFactory: burgerFactory,
    });

    ledgerActor = await window.ic.plug.createActor({
      canisterId: LEDGER_CANISTER_ID,
      interfaceFactory: ledgerFactory,
    }); 
  
    isShopClosed = await burgerShop.isShopClosed();

    let burgerAvailableBigInt = await burgerShop.burgerAvailable();
    let burgerAvailableString = burgerAvailableBigInt + "";
    burgerAvailable = parseInt(burgerAvailableString);    
    

    g_principalID = await window.ic.plug.agent.getPrincipal();

    console.log("Principle =" + g_principalID);

    var selectedAccount = g_principalID + "";

    isPlugWallet = true;

    document.getElementById("Connect").innerText = selectedAccount.substring(0, 3) + "..." + selectedAccount.substring(selectedAccount.length - 3);
    document.getElementById("Who-Hungy").style.display = "inline";
    document.getElementById("Connect").removeAttribute('onclick');
    
    isPaid = false;
    return 1;  
  };

document.getElementById("StoicConnect").addEventListener("click", async () => 
{
  document.getElementById("Connect").classList.add("disabled");

  isPlugWallet = false;
  connectStoicWallet();

  isPaid = false;
  document.getElementById("Connect").innerText = "Connecting...";
  document.getElementById("StoicConnect").classList.add("disabled");
  document.getElementById("Connect").classList.add("disabled");
  document.getElementById("StoicConnect").style.display = "none";


});

async function  connectStoicWallet()
{

  try
  {
      var identity = await StoicIdentity.connect();
      g_principalID = identity.getPrincipal();

      console.log("Authorization to Stoic wallet successful!");
      console.log("Your Stoic Wallet Principal is " + g_principalID);

      var selectedAccount = g_principalID + "";

      isPlugWallet = false;

      
      document.getElementById("Check-Claim").style.display = "flex";      
      document.getElementById("Connect").innerText = selectedAccount.substring(0, 3) + "..." + selectedAccount.substring(selectedAccount.length - 3);
      document.getElementById("Who-Hungy").style.display = "inline";
      document.getElementById("Connect").removeAttribute('onclick');

      //StoicWallet actors
      bunnyActor = Actor.createActor(bunnyFactory, {
        agent: new HttpAgent({
          identity: identity,
          host: "https://ic0.app",
        }),
        canisterId: bunnyCanisterId,
      }); 
    
      carrotActor = Actor.createActor(carrotFactory, {
        agent: new HttpAgent({
          identity: identity,
          host: "https://ic0.app",
        }),
        canisterId: carrotCanisterId,
      });  

      burgerShop = Actor.createActor(burgerFactory, {
        agent: new HttpAgent({
          identity: identity,
          host: "https://ic0.app",
        }),
        canisterId: burgerFinanceCanisterID,
      });        

      ledgerActor = Actor.createActor(ledgerFactory, {
        agent: new HttpAgent({
          identity: identity,
          host: "https://ic0.app",
        }),
        canisterId: LEDGER_CANISTER_ID,
      }); 
    
    
      isShopClosed = await burgerShop.isShopClosed();


      let burgerAvailableBigInt = await burgerShop.burgerAvailable();
      let burgerAvailableString = burgerAvailableBigInt + "";
      burgerAvailable = parseInt(burgerAvailableString); 

      return 1;        

  
  } 
  catch (error) {
    console.log("Authorization Exception in Stoic Wallet "+ error);
    return -1;
  }  
}

document.getElementById("Connect").addEventListener("click", async () => 
{
    isPlugWallet = true;
    if(isWalletConnected)
    {
      return 0;
    }
    document.getElementById("Connect").classList.add("disabled");
    document.getElementById("StoicConnect").style.display = "none";

    initPlugWallet();
    document.getElementById("Connect").innerText = "Connecting...";
    
    var selectedAccount = g_principalID + "";
    console.log("This is the principal" + g_principalID);
    isWalletConnected = true;
});


document.getElementById("Who-Hungy").addEventListener("click", async () => 
{
    if(bunnyLoaded)
    {
      return true;
    }
    document.getElementById("Hungy-Gobbies").classList.toggle("active");
    document.getElementById("Who-Hungy").innerHTML = "Loading 🐇🐰..";

    getICPBunny();

});

const getICPBunny = async () => {
 

    if(isPlugWallet)
    {
      g_principalID = await window.ic.plug.agent.getPrincipal();

      /*
      bunnyActor = await window.ic.plug.createActor({
        canisterId: bunnyCanisterId,
        interfaceFactory: bunnyFactory,
      });
  
      carrotActor = await window.ic.plug.createActor({
        canisterId: carrotCanisterId,
        interfaceFactory: carrotFactory,
      });
      */

    }
    else
    {
      /*
      var identity = await StoicIdentity.connect();
      g_principalID = identity.getPrincipal();

      
      bunnyActor = Actor.createActor(bunnyFactory, {
        agent: new HttpAgent({
          identity: identity,
          host: "https://ic0.app",
        }),
        canisterId: bunnyCanisterId,
      }); 
    
      carrotActor = Actor.createActor(carrotFactory, {
        agent: new HttpAgent({
          identity: identity,
          host: "https://ic0.app",
        }),
        canisterId: carrotCanisterId,
      });       
      */
    }

  
    let no_of_Carrots_Int = 0;
    console.log("Principal = "+ g_principalID);
  
      
      if (carrotActor != null && g_principalID != null) {
        let no_of_CarrotsBigInt = await carrotActor.balance_of(g_principalID);

        let no_of_CarrotsString = no_of_CarrotsBigInt + "";
        no_of_Carrots_Int = parseInt(no_of_CarrotsString);

        no_of_Carrots_Int = (no_of_Carrots_Int / 100000000);

        document.getElementById("isICPPayment").value = no_of_Carrots_Int;

        console.log("Carrots value 1" + no_of_Carrots_Int);
        console.log(document.getElementById("isICPPayment").value);        
        if(no_of_Carrots_Int < 999)
        {
          console.log("Carrots less ");
          isPayICP = true;
        }

        var carrots = await nFormatter(no_of_Carrots_Int,2);
       // Get Bunny
    
      var shopStatus = "";
      var shopColor = "green";
       if(burgerAvailable == 0 || isShopClosed)
       {
          if(isShopClosed)
          {
            shopStatus = "🏪 Closed 😕";
            shopColor = "red";        
          }
          else
          {
            shopStatus = "🍔 Sold-out";
            shopColor = "red";        
          }
       }
       else
       {
        shopStatus = "🍔 Stock: " + burgerAvailable;
        shopColor = "green";
       }
        
        document.getElementById("Carrot-Amount").style.display = "inline";
        document.getElementById("Carrot-Amount").innerText = "Total " + carrots + " 🥕";

        document.getElementById("Burger-Available").style.display = "inline";
        document.getElementById("Burger-Available").innerText = shopStatus;
        document.getElementById("Burger-Available").style.color = shopColor;


      }   

    var  MAX_TOKENS = 0;
    if (bunnyActor != null) {
      myTokens = await bunnyActor.user_tokens(g_principalID);
  
      console.log("myTokens = " + myTokens);
  
      MAX_TOKENS = myTokens.length;

      console.log("Total Bunnies " + MAX_TOKENS);

      var total = myTokens.length;  
   
      var bunnyCount = 0;
      for (var i = 0; i < total; i++) 
      {
        var t = myTokens[i] + "";
        let token = t;
        if(token < 10000)
        {
          bunnyCount++;
        }
      } 
      total = bunnyCount;

      /*
      if(isShopClosed) // When shop is closed take to DEMO mode
        total = 0;
      */

      if (total === 0) {
        isDemoMode  = true;
        document.getElementById("Who-Hungy").innerHTML = "No ICPBunny :(";
        let image = "https://oi3q2-xqaaa-aaaai-acncq-cai.ic0.app/burger_files/logo.png";
        document.getElementById("showGobs").innerHTML += "<div class='item' onclick='selectGoblinDemo()'>" +
            "<div class='pfp'>" +
            "<img src='" + image + "'>" +
            "</div>" +
            "<div class='pfp-token'>Demo Mode</div>" +
            "</div>";
      }  
      else {     

        bunnyLoaded = true;
        var claimStatus = [];
        var bunnyCount  = 0;


        bunnyCount = 0;
        for (var i = 0; i < total; i++) 
        {

            //let claimed = Check whether Burgers are claimed by the Bunny ID

            var t = myTokens[i] + "";
            let token = t;

            if(token < 10000)
            {
              console.log("Loading images " + (i + 1) + "/" + MAX_TOKENS + ", " + t);
              console.log("Current Bunny ID = " + token);
          
              let canisterIndex = parseInt(t) % 10;
              let storageCanister = storage[canisterIndex];
        
              let image = "https://" + storageCanister + ".raw.ic0.app/Token/" + t;
  
              var claimed = claimStatus[bunnyCount];
              bunnyCount++;
              /***********************************/
              // Debugging and Testing only
              /***********************************/

              claimed = await burgerShop.isBunnyClaimed(Number(token));
              
              

              console.log(claimed);
              if (claimed) {
                  document.getElementById("showGobs").innerHTML += `<div class="item claimed" onclick="selectGoblin(` + token + `)">` +
                      `<div class="pfp">` +
                      `<img src="` + image + `">` +
                      `</div>` +
                      `<div class="pfp-token">#` + token + `</div>` +
                      `</div>`;
              } else {
                  document.getElementById("showGobs").innerHTML += `<div class="item" onclick="selectGoblin(` + token + `)">` +
                      `<div class="pfp">` +
                      `<img src="` + image + `">` +
                      `</div>` +
                      `<div class="pfp-token">#` + token + `</div>` +
                      `</div>`;
              }
            }

        }
          
        document.getElementById("Who-Hungy").innerHTML = "Select Bunny";
        document.getElementById("Who-Hungy").classList.add("disabled");
        document.getElementById("Who-Hungy").removeAttribute('onclick');
    }
    }
    }

    //Avail-Btn
    document.getElementById("Avail-Btn").addEventListener("click", async () => 
    {
      try {
          var token = document.getElementById("check").value;

          burgerShop = await window.ic.plug.createActor({
            canisterId: burgerFinanceCanisterID,
            interfaceFactory: burgerFactory,
          });          
          
          let isClaimed = await burgerShop.isBunnyClaimed(Number(token));

          
          if (token > 9999 || token < 0 || isNaN(token)) {
              document.getElementById("Avail-Btn").innerHTML = "Bunny Not Exist";
              await delay(3);
              document.getElementById("check").value = "";
              document.getElementById("Avail-Btn").innerHTML = "Check If Bunny Orderd";
          } else {
              if (isClaimed === false) {
                  document.getElementById("Avail-Btn").innerHTML = "Bunny Hungry";
                  document.getElementById("Avail-Btn").style.color = "green"
                  await delay(10);
                  document.getElementById("Avail-Btn").style.color = "black"
                  document.getElementById("check").value = "";
                  document.getElementById("Avail-Btn").innerHTML = "Check If Bunny Orderd";
              } else {
                  document.getElementById("Avail-Btn").innerHTML = "Bunny Orderd";
                  document.getElementById("Avail-Btn").style.color = "red"
                  await delay(10);
                  document.getElementById("Avail-Btn").style.color = "black"
                  document.getElementById("check").value = "";
                  document.getElementById("Avail-Btn").innerHTML = "Check If Bunny Orderd";
              }
          } 
      } 
      catch (err) {
          console.log("Error in check claim Bunny ");
      }
  });

  document.getElementById("Claim-Burgur").addEventListener("click", async () => 
  {
      if(isPaid)
      {
        //Already paid;
        return 0;
      }

      document.getElementById("Hungy-Gobbies").classList.toggle("active");
      document.getElementById("Who-Hungy").innerHTML = "Loading Bunnies..";
      document.getElementById('Claim-Burgur').removeAttribute("onclick");


      document.getElementById("Talky-Talky").style.display = "flex";        

      var orderProgress = document.getElementById("OrderProgress");

      var hashBackground = 0;
      var hashSauce = 0;
      var hashMeat = 0;
      var hashCheese = 0;
      var hashToppings = 0;
      var hashBun = 0;
      var selectedBunny = 0;
      var from_sa = 0;

      hashBackground  = document.getElementById("hashBackground").value;
      hashSauce       = document.getElementById("hashSauce").value;
      hashMeat        = document.getElementById("hashMeat").value;
      hashCheese      = document.getElementById("hashCheese").value;
      hashToppings    = document.getElementById("hashToppings").value;
      hashBun         = document.getElementById("hashBun").value;
      selectedBunny  = document.getElementById("selectedBunny").value;

      document.getElementById("Claim-Burgur").innerHTML = "🍔 beeing made.."
      

      if(isDemoMode)
      {
        orderProgress.innerHTML = "Enjoying the demo mode already?!<br><p>Grab some Bunny now! <a class='clickable' href='https://bit.ly/burger2entrepot' target='_blank'>Go to Entrepot !</a></p>";  
        return false;
      }

      if(isShopClosed)
      {
        orderProgress.innerHTML = "Mc Dominic's 🍔 inguration on Oct-14-2022 12.00 UTC by<br> CEO Dominic Williams ∞";  
        return false;
      }

      if(burgerAvailable == 0)
      {
        orderProgress.innerHTML = " 🍔 SOLD OUT NOW COME-BACK TOMORROW ";  
        return false;
      }      
      

      orderProgress.innerHTML = "🍔 beeing made..";

      let no_of_Carrots_Int = 0;     
  
      console.log("Carrots Principal" + g_principalID);


        document.getElementById("Sauce-Thumbs").classList.remove("active");
        document.getElementById("Topping-Thumbs").classList.remove("active");
        document.getElementById("Meat-Thumbs").classList.remove("active");
        document.getElementById("Cheese-Thumbs").classList.remove("active");
        document.getElementById("Bun-Thumbs").classList.remove("active");
        document.getElementById("Sides-Thumbs").classList.remove("active");
        document.getElementById("Sauce-Trigger").style.display = "none";
        document.getElementById("Meat-Trigger").style.display = "none";
        document.getElementById("Cheese-Trigger").style.display = "none";
        document.getElementById("Topping-Trigger").style.display = "none";
        document.getElementById("Sides-Trigger").style.display = "none";
        document.getElementById("Buns-Trigger").style.display = "none";

        document.getElementById("hashBackground").value = 0;
        document.getElementById("hashSauce").value  = 0;
        document.getElementById("hashMeat").value = 0;
        document.getElementById("hashCheese").value = 0;
        document.getElementById("hashToppings").value = 0;
        document.getElementById("hashBun").value = 0;
        document.getElementById("selectedBunny").value = 0;
      
      if (carrotActor != null && g_principalID != null) {
        let no_of_CarrotsBigInt = await carrotActor.balance_of(g_principalID);
        let no_of_CarrotsString = no_of_CarrotsBigInt + "";
        no_of_Carrots_Int = parseInt(no_of_CarrotsString);

        no_of_Carrots_Int = (no_of_Carrots_Int / 100000000);
        console.log("Carrots value 2" + no_of_Carrots_Int);
        document.getElementById("isICPPayment").value = no_of_Carrots_Int;

        console.log(document.getElementById("isICPPayment").value);

        if(no_of_Carrots_Int < 999)
        {
          console.log("Carrots less ");
          isPayICP = true;
        } 


        var carrots = await nFormatter(no_of_Carrots_Int,2);
        document.getElementById("Carrot-Amount").style.display = "inline";
        document.getElementById("Carrot-Amount").innerText = "Total " + carrots + " 🥕";


        const transferTo = "vwwmp-om32r-tgzpy-3lx3m-a5qbm-5pst6-xfdoi-gtivj-trcp6-k3dch-5ae";
        const transferToAccountID = principalToAccountIdentifier(transferTo,4);

        if(isPayICP)
        {

          console.log("Payment started..");
          orderProgress.innerHTML = "Transfering  2 ♾️";

          const transferFrom = g_principalID+"";
          const transferAccountID = principalToAccountIdentifier(transferFrom,0);

          var BlockHeight = 0;

          console.log(transferToAccountID);
          console.log(transferAccountID);
        
          var isCarrot = false;

          var balanceArgs = {
            "account" : transferAccountID
          };  

          var balance = await ledgerActor.account_balance_dfx(balanceArgs);  //Plug-Wallet
          console.log("Balance  " + (balance.e8s/10000000n));  
          
          var transfer = balance.e8s - 10000n;
          var mintFee = parseInt(2) * decimals;

          if(transfer < mintFee)
          {
            document.getElementById("Claim-Burgur").innerHTML = "Less ICP"; 
            orderProgress.innerHTML = "Insufficient ICP ♾️";
            return false;
          }    
          var args = {
            "from_subaccount" : [getSubAccountArray(from_sa ?? 0)], 
            "to" : transferToAccountID,
            "amount" : { "e8s" : mintFee},
            "fee" : { "e8s" : 10000n }, 
            "memo" : 1  , 
            "created_at_time" : []
          }

          bunnySong.pause();
          makinBurgurs.play();

          isCarrot = false;
          BlockHeight = await ledgerActor.send_dfx(args);
          console.log("Transaction successful!");
          console.log("Blockheight " + BlockHeight);      
        }
        else
        {
          orderProgress.innerHTML = "Transfering  999 🥕";

          bunnySong.pause();
          makinBurgurs.play();
          
          isCarrot = true;
          console.log("Transfering carrots " + nCarrots);
          BlockHeight = 9999;
          var result = await carrotActor.walletTransfer(nCarrots, g_carrot_principal_ID);
          console.log(result);
          console.log(g_carrot_principal_ID)

        }

        var isICPPayment    = 1;        // Default to ICP
        var isCarrotPayment = 0;
        var paidICP         = mintFee;
        var paidCarrots     = payCarrots;
        var paidAmount      = mintFee;  // Default to ICP

        var remarks = "ICP Paid to "+ transferToAccountID;

        if(isCarrot)
        {
          isICPPayment = 0;
          isCarrotPayment = 1;
          paidAmount  = paidCarrots;
          remarks = "Carrots Paid to " + g_carrot_principal_ID;
        }


        console.log(hashBackground);
        console.log(hashSauce);
        console.log(hashMeat);
        console.log(hashCheese);
        console.log(hashToppings);
        console.log(hashBun);  
        console.log(selectedBunny);        

        var index      = Math.floor(Math.random() * 5) + 1;
        var burgerCode = privateKey[index] * RSAKey[index];

        var burgerParam = {
          icp : isICPPayment,
          owner : g_principalID,
          desc : "",
          name : "",
          properties: [
            { name: 'Drinks', value: hashBackground },
            { name: 'Sauce', value: hashSauce },
            { name: 'Meat', value: hashMeat },
            { name: 'Cheese', value: hashCheese },
            { name: 'Toppings', value: hashToppings },
            { name: 'Bun', value: hashBun },
            { name: 'Remarks', value: remarks },
          ],
          blockheight : Number(BlockHeight),
          bunny_id : Number(selectedBunny),
          carrot : isCarrotPayment,
          amount : paidAmount,
        };
        document.getElementById("Claim-Burgur").innerHTML = "here u go"

        isPaid = true;
        orderProgress.innerHTML = "Finalizing your order !";

        var orderStatus = await burgerShop.assembleBurger(burgerParam,burgerCode);
        
        orderProgress.innerHTML = "Order confirmed orderid :" + orderStatus.id;

        document.getElementById("thankyou").style.display = "block";

      }      

      console.log("Carrots Balance : " + no_of_Carrots_Int);
  
  });


  async function nFormatter(num, digits) {
    const lookup = [
      { value: 1, symbol: "" },
      { value: 1e3, symbol: "k" },
      { value: 1e6, symbol: "M" },
      { value: 1e9, symbol: "G" },
      { value: 1e12, symbol: "T" },
      { value: 1e15, symbol: "P" },
      { value: 1e18, symbol: "E" }
    ];
    const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
    var item = lookup.slice().reverse().find(function(item) {
      return num >= item.value;
    });
    return item ? (num / item.value).toFixed(digits).replace(rx, "$1") + item.symbol : "0";
  }

/***************************************************************************/
const principalToAccountIdentifier = (p, s) => {
  const padding = Buffer("\x0Aaccount-id");
  const array = new Uint8Array([
      ...padding,
      ...Principal.fromText(p).toUint8Array(),
      ...getSubAccountArray(s)
  ]);
  const hash = sha224(array);
  const checksum = to32bits(getCrc32(hash));
  const array2 = new Uint8Array([
      ...checksum,
      ...hash
  ]);
  return toHexString(array2);
};
/***************************************************************************/
const toHexString = (byteArray)  =>{
  return Array.from(byteArray, function(byte) {
    return ('0' + (byte & 0xFF).toString(16)).slice(-2);
  }).join('')
}
/***************************************************************************/
const to32bits = num => {
  let b = new ArrayBuffer(4);
  new DataView(b).setUint32(0, num);
  return Array.from(new Uint8Array(b));
};
const fromHexString = (hex) => {
  if (hex.substr(0,2) === "0x") hex = hex.substr(2);
  for (var bytes = [], c = 0; c < hex.length; c += 2)
  bytes.push(parseInt(hex.substr(c, 2), 16));
  return bytes;
};
/***************************************************************************/
const getSubAccountArray = (s) => {
  if (Array.isArray(s)){
    return s.concat(Array(32-s.length).fill(0));
  } else {
    //32 bit number only
    return Array(28).fill(0).concat(to32bits(s ? s : 0))
  }
};
/******************* Payment method end heres *********************/
